<template>
  <div class="animated fadeIn">
    <div class="card card-blue">
      <div class="card-body">
        <div class="row mb-2">
          <div class="col-12">
            <button type="button" class="btn btn-primary button-add pull-right" @click="showModal()">{{$t('NEW')}}</button>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 table-responsive">
              <table class="table table-sm table-bordered table-striped table-hover table-logoped">
                <thead>
                  <tr>
                    <th>
                      <sortingcolumn v-model="pagination" field="first_name" v-on:reload="getData">{{$t('FIRSTNAME')}}</sortingcolumn>
                    </th>
                    <th>
                      <sortingcolumn v-model="pagination" field="last_name" v-on:reload="getData">{{$t('LASTNAME')}}</sortingcolumn>
                    </th>
                    <th>
                      <sortingcolumn v-model="pagination" field="date_of_birth" v-on:reload="getData">{{$t('DATEOFBIRTH')}}</sortingcolumn>
                    </th>
                    <th>
                      <sortingcolumn v-model="pagination" field="phone_number" v-on:reload="getData">{{$t('PHONENUMBER')}}</sortingcolumn>
                    </th>
                    <th>
                      <sortingcolumn v-model="pagination" field="therapy_name" v-on:reload="getData">{{$t('THERAPYTYPE')}}</sortingcolumn>
                    </th>
                    <th>
                      <sortingcolumn v-model="pagination" field="contact_date" v-on:reload="getData">{{$t('CONTACTDATE')}}</sortingcolumn>
                    </th>
                    <th>{{$t('ACTION')}}</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="item in response.root">
                    <tr :key="item.id" aria-rowindex="1" class=" table-ellipsis">
                      <td>{{item.first_name}}</td>
                      <td>{{item.last_name}}</td>
                      <td>{{formatDate(item.date_of_birth)}}</td>
                      <td>{{item.phone_number}}</td>
                      <td>
                        <span v-if="item.therapy_name">
                          {{item.therapy_name}}
                        </span>
                        <span v-else class="text-muted">{{$t('NOTASSIGNED')}}</span>
                      </td>
                      <td>{{formatDate(item.contact_date)}}</td>
                      <td>
                        <button type="button" class="btn button-edit mr-2"  @click="showModal(item)">{{$t('EDIT')}}</button>
                        <button type="button" class="btn button-dlt" @click="deleteRow(item.id)">{{$t('DELETE')}}</button>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
              <nav>
                <pagination
                  v-bind:totalCount="response.totalCount"
                  v-model="pagination"
                  v-on:reload="getData"></pagination>
              </nav>
          </div>
        </div>
      </div>
    </div>
    <b-modal ref="formmodal" :title="$t('WAITLISTINDIVIDUALSESSIONSFORM')" ok-title="submit" hide-footer no-close-on-backdrop>
      <div class="d-block">
        <waitlistindividualsessionsform v-bind:formData="formData"
          v-bind:formError="formError"
          v-bind:therapyTypes="therapyTypes"></waitlistindividualsessionsform>
      </div>
      <div class="text-right">
        <b-btn class="button-cancel mr-2" @click="hideModal()">{{$t('CANCEL')}}</b-btn>
        <b-btn class="button-save" @click="submitData(formData)">{{$t('SAVE')}}</b-btn>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Api from '@/api/waitlist_individual_sessions/WaitlistIndividualSessions';
import TherapyTypesApi from '@/api/therapy/TherapyType';
import WaitlistIndividualSessionsForm from './Form.vue';
import moment from "moment/moment";

export default
{
    name: 'WaitlistIndividualSessions',
    components:
  {
      waitlistindividualsessionsform: WaitlistIndividualSessionsForm,
  },
    data()
    {
        return {
            response: {},
            therapyTypes: {},
            formError: {},
            formData: {
                first_name: '',
                last_name: '',
                date_of_birth: '',
                phone_number: '',
                therapy_id: null,
                owner_id: null,
                notes: '',
                contact_date: '',
            },
            pagination: {
                query: '',
                currentPage: 1,
                limit: 25,
                searchTimeout: false,
            },
        };
    },
    created()
    {
        const me = this;
        me.getData();
        me.getTherapyTypes();
    },
    methods:
  {
      async getData()
      {
          const me = this;
          try
          {
              const data = await Api.selectRow(me.getParams);
              if (data.error && data.error === true)
              {
                  me.$notify.notice(data);
                  me.loading = false;
                  return;
              }

              me.response = data;
          }
          catch (e)
          {
              me.$notify.notice(e);
          }
      },
      async getTherapyTypes()
      {
          const me = this;
          try
          {
              const data = await TherapyTypesApi.selectRow();
              if (data.error && data.error === true)
              {
                  me.$notify.notice(data);
                  return;
              }

              me.therapyTypes = data;
          }
          catch (e)
          {
              me.$notify.notice(e);
          }
      },
      async deleteRow(id)
      {
          const me = this;
          try
          {
              me.$store.commit('setModalAlert',
                  {
                      text: me.$i18n.t('AREYOUSHURE'),
                      async btnAction()
                      {
                          const data = await Api.deleteRow(
                              {
                                  id,
                              },
                          );
                          me.$notify.notice(data);
                          await me.getData();
                      },
                  });
          }
          catch (e)
          {
              me.$notify.notice(e);
          }
      },
      showModal(item)
      {
          const me = this;
          if (typeof item !== 'undefined')
          {
              me.formData = { ...item };
          }
          this.$refs.formmodal.show();
      },
      async submitData(item)
      {
          const me = this;
          try
          {
              if (typeof item.id !== 'undefined')
              {
                  item.id = item.id;
              }

              const data = await Api.submitData(item);
              if (data.error)
              {
                  me.$notify.notice(data);
                  me.formError = data;
              }
              else
              {
                  me.$notify.notice(data);
                  me.hideModal();
                  await me.getData();
              }
          }
          catch (e)
          {
              me.$notify.notice(e);
          }
      },
      hideModal()
      {
          const me = this;
          this.$refs.formmodal.hide();

          me.formData = {
              first_name: '',
              last_name: '',
              date_of_birth: '',
              phone_number: '',
              therapy_id: null,
              owner_id: null,
              notes: '',
              contact_date: '',
          };
          me.formError = {};
      },
      formatDate(date)
      {
          if (!date) return '';
          return moment.utc(date).local().format('DD.MM.YYYY');
      },
  },
    watch:
  {
      'pagination.limit'()
      {
          const me = this;
          me.getData();
      },
      'pagination.currentPage'()
      {
          const me = this;
          me.getData();
      },
      'pagination.query'()
      {
          const me = this;

          if (me.pagination.searchTimeout !== false)
          {
              clearTimeout(me.pagination.searchTimeout);
          }

          me.pagination.searchTimeout = setTimeout(() =>
          {
              me.getData();
              me.pagination.searchTimeout = false;
          }, 300);
      },
  },
    computed:
  {
      getParams()
      {
          const me = this;
          const data = {
              ...me.pagination,
          };
          data.start = (data.currentPage - 1) * data.limit;
          return data;
      },
  },
};
</script>
